export default function ThemeItem({
  theme,
  idx,
  formData,
  setFormData,
  setThemeFormData,
}) {
  function handleClick(evt) {
    const themeId = evt.target.id;
    if (formData.themes.includes(themeId)) {
      const newFormData = { ...formData };
      const index = newFormData.themes.indexOf(themeId);
      newFormData.themes.splice(index, 1);
      setFormData(newFormData);
    } else {
      const newFormData = { ...formData };
      newFormData.themes.push(themeId);
      setFormData(newFormData);
    }
    if (setThemeFormData) setThemeFormData("");
  }
  return (
    <p
      key={idx}
      id={theme._id}
      onClick={handleClick}
      className={`border rounded-full px-3 py-1 text-sm cursor-pointer transition-colors ${formData.themes.includes(theme._id) ? "bg-gray-700 text-white border-gray-700" : "bg-gray-100 text-gray-600 border-gray-300 hover:border-gray-500"}`}
    >
      {theme.themeName}
    </p>
  );
}
